import "../css/footer.css";
import icontec from "../img/ICONTEC-wh.png";

function Footer() {
  return (
    <>
      <footer className="footer text-center">
        <div className="container">
          <div className="row align-items-center">
            {/* Footer Location */}
            <div className="col-lg-4 mb-5 mb-lg-0">
              <h4 className="text-uppercase mb-4">Ubicación</h4>
              <p className="lead mb-0">
                Ac. 26 #69-76 Torre 4 / Piso 9 -10
                <br />
              </p>
            </div>
            {/* Imagen */}
            <div className="col-lg-4 mb-5 mb-lg-0">
              <img
                src={icontec}
                width={170}
                className="img-fluid"
                alt="ICONTEC logo"
              />
            </div>
            {/* Footer Social Icons */}
            <div className="col-lg-4 mb-5 mb-lg-0">
              <h4 className="text-uppercase mb-4">Sitio Web</h4>
              <a href="https://icontec.org" download>
                ICONTEC
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
